import InfoIcon from '@mui/icons-material/Info';
import { Dialog, DialogContent, DialogContentText, IconButton } from '@mui/material';
import { useState } from 'react';

import { DialogTitleWithX, TypographyTranslated } from '@sh4res/bo-common/components';

import { AxaTypography } from '@Components/AxaTypography';

export function EnterpriseCodeInfoButton({ testId }: { testId: string }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <IconButton data-testid={testId} onClick={handleOpen} size="small">
        <InfoIcon />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xs"
        sx={{ '& .MuiDialog-paper': { borderRadius: '30px !important' } }}>
        <DialogTitleWithX borderBottom="0 !important" onClose={handleClose}>
          <TypographyTranslated
            label={'login_page.messages.form.external_code_enterprise.helper_dialog.title'}
            component={AxaTypography}
            variant="h5"
            align="center"
          />
        </DialogTitleWithX>
        <DialogContent>
          <DialogContentText>
            <TypographyTranslated
              label={'login_page.messages.form.external_code_enterprise.helper_dialog.text'}
            />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}
